module.exports={
  noResult:            'Aerolínea no encontrado'
}
